import "reflect-metadata";

export function TimestampDateMatch() {

    return function (target: any, propertyKey: string) {

        const datePropertiesKey = 'dateProperties';
        let value = target[propertyKey];

        const datePropertiesMetadata: string[] = Reflect.getOwnMetadata(datePropertiesKey, target) || [];

        datePropertiesMetadata.push(propertyKey);
        Reflect.defineMetadata(datePropertiesKey, datePropertiesMetadata, target);

    }
}
